import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import FieldInput from 'brastrap/common/field-input/FieldInput';
import FieldSet from 'brastrap/common/fieldset/Fieldset';
import { emailOptIn } from 'shared/actions/email-signup';
import { Back, Next } from '../ControlButtons';
import { dataLayerGA4SizeQuizStageNumber } from '../../../shared/utils/data-layer';

const Stage11 = ({
  backChange,
  backSize,
  cachedCupSize,
  cupChange,
  convertFromUSToUKSize,
  country,
  cupSize,
  defaultPreviousProps,
  defaultNextProps,
  finalAdjustment,
  intl: { formatMessage, locale },
  messages,
  resetCup,
  setNextStage,
  setPartTwoSelected,
  setTempCupCache,
  submitEmail,
  togglePartTwo,
}) => {
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(true);
  const [ukCupSize, setUKCupSize] = useState(null);

  const finalSize = [backSize, ukCupSize].join('');

  const STAGE_NUMBER = '11';
  const cupSizeToUse = finalAdjustment(backChange, country, cupChange, cupSize);

  const privacyLink =
    locale === 'en-US' && country === 'en-US'
      ? '/us/privacy-and-legal/'
      : '/privacy/';

  useEffect(() => {
    dataLayerGA4SizeQuizStageNumber(STAGE_NUMBER);
    if (locale === 'en-US' && country === 'en-US') {
      setUKCupSize(convertFromUSToUKSize(cupSizeToUse));
    } else {
      setUKCupSize(cupSizeToUse);
    }
  }, []);

  let buttonSubmitClassName = 'btn-email-submit ';

  if (!isValidEmail || !isCheckboxEnabled) {
    buttonSubmitClassName += 'disabled';
  } else if (isValidEmail && isCheckboxEnabled) {
    buttonSubmitClassName += 'show';
  }

  const handleEmailSubmission = e => {
    e.preventDefault();
    submitEmail({ formKey: 'web-size-quiz', email, size: finalSize });
  };

  const validateEmail = emailAddress => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(emailAddress);
  };

  const handleEmailChange = event => {
    const inputValue = event.target.value;
    setEmail(inputValue);
    setIsValidEmail(validateEmail(inputValue));
  };

  return (
    <>
      <Back
        {...defaultPreviousProps(4, formatMessage(messages.restartCupSize))}
        customFunc={() => {
          setPartTwoSelected(0);
          togglePartTwo(false);
          resetCup(cachedCupSize);
          setTempCupCache({ cupSize: cachedCupSize, cupChange: 0 });
        }}
      />
      <div className="stage stage-11">
        <div className="wrap">
          <div className="header-container">
            <h2 className="header u-text-size-2">
              {formatMessage(messages.stage11h2)}
            </h2>
            <p className="sub-header">{formatMessage(messages.stage11para1)}</p>
          </div>
          <form
            method="POST"
            className="c-sizeQuiz-form"
            onSubmit={e => {
              handleEmailSubmission(e);
              setNextStage(1);
            }}
          >
            <div className="c-sizeQuiz-form-inputField">
              <FieldSet modifiers={['size-quiz']}>
                <FieldInput
                  required
                  id="email"
                  type="email"
                  value={email}
                  placeholder="Email address"
                  modifiers={['white']}
                  onChange={e => handleEmailChange(e)}
                />
              </FieldSet>
            </div>
            <div className="btn-container-size-quiz">
              <button
                disabled={!isValidEmail || !isCheckboxEnabled}
                className={buttonSubmitClassName}
                type="submit"
              >
                {formatMessage(messages.submitEmail)}
              </button>
              <Next
                id="btn-skip-to-result"
                {...defaultNextProps(1, 'Skip to results')}
              />
              <div className="checkbox-container-size-quiz">
                <input
                  id="promo-checkbox"
                  type="checkbox"
                  value={isCheckboxEnabled}
                  checked={isCheckboxEnabled}
                  onChange={() => setIsCheckboxEnabled(isChecked => !isChecked)}
                />
                <label htmlFor="promo-checkbox">
                  {formatMessage(messages.stage11promoCheckbox)}
                </label>
              </div>
              <p className="privacy-policy">
                Our privacy policy is{' '}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={privacyLink}
                  className="privacy-policy-link"
                >
                  here
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  submitEmail: (formKey, email, size) =>
    dispatch(emailOptIn(formKey, email, size)),
});
const WrappedStage11 = injectIntl(connect(null, mapDispatchToProps)(Stage11));
export default WrappedStage11;

Stage11.propTypes = {
  backSize: PropTypes.string,
  backChange: PropTypes.number,
  cachedCupSize: PropTypes.string,
  convertFromUSToUKSize: PropTypes.func,
  country: PropTypes.string,
  cupChange: PropTypes.number,
  cupSize: PropTypes.string,
  defaultPreviousProps: PropTypes.func,
  defaultNextProps: PropTypes.func,
  finalAdjustment: PropTypes.func,
  intl: intlShape,
  messages: PropTypes.object,
  Next: PropTypes.func,
  resetCup: PropTypes.func,
  setNextStage: PropTypes.func,
  setPartTwoSelected: PropTypes.func,
  setTempCupCache: PropTypes.func,
  submitEmail: PropTypes.func,
  togglePartTwo: PropTypes.func,
};
